import {AfterViewInit, Component, OnInit} from '@angular/core';
import {acceptCookie, getCookie} from '../../utils/cookie.utils';

const COOKIE_INVITE_NAME = 'invitedCount';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css'],
})
export class BannerComponent implements OnInit, AfterViewInit {

  // private intervalId;

  constructor(
  ) {
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    const cookie = getCookie(COOKIE_INVITE_NAME);

    let cookieCount = parseInt(cookie, 10);

    if (isNaN(cookieCount)) {
      cookieCount = 0;
    }

    if (cookieCount >= 2) {
      return;
    }

    setTimeout(() => {
      acceptCookie(COOKIE_INVITE_NAME, `${++cookieCount}`);
    }, 5000);
  }
}
